import React, {useMemo} from 'react';

import {EmailDeliveryLogStatus} from 'src/openapi/admin/models/EmailDeliveryLog';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {Tooltip} from '@pb/kit-component-popups';


import {STATUS_DESCRIPTIONS} from '../../constants';

type Props = {
    statusCode: EmailDeliveryLogStatus,
};

export const DeliveryStatusCell = ({statusCode}: Props) => {
    const statusDescription = useMemo(() => {
        const status = STATUS_DESCRIPTIONS[statusCode];
        return status ? status.description : statusCode;
    }, [statusCode]);

    const statusTitle = useMemo(() => {
        const status = STATUS_DESCRIPTIONS[statusCode];
        return status ? status.title : statusCode;
    }, [statusCode]);

    return (
        <Tooltip
            color="light"
            anchor={({anchorRef, getAnchorProps}) => (
                <div ref={anchorRef} {...getAnchorProps()}>
                    <EllipsisTextHint title={statusDescription}>
                        {statusTitle}
                    </EllipsisTextHint>
                </div>
            )}>
            {STATUS_DESCRIPTIONS[statusCode].description}
        </Tooltip>
    );
};
